import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Divider } from "@redotech/redo-web/divider";
import { Flex } from "@redotech/redo-web/flex";
import { useFooter } from "./use-footer";

export function Footer({ centered = false }: { centered?: boolean }) {
  const { texts, policyLinkTextClicked, notificationHtml } = useFooter();
  return (
    <Flex
      align={centered ? "center" : "flex-start"}
      flexDirection="column"
      gap="3xl"
    >
      <Flex flexDirection="column" w="full">
        <Divider />
      </Flex>

      <Flex align={centered ? "center" : "flex-start"} flexDirection="column">
        <div
          dangerouslySetInnerHTML={{ __html: notificationHtml || "" }}
          style={{ textAlign: "center" }}
        />
        <RedoButton
          hierarchy="link_underline"
          onClick={policyLinkTextClicked}
          text={texts.policyLinkButton}
        />
      </Flex>
    </Flex>
  );
}
